import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";

import Header from "@/components/nexus/Header";
import Hero from "@/components/nexus/Hero";
import About from "@/components/nexus/About";
import BusinessUnits from "@/components/nexus/BusinessUnits";
import Diferenciais from "@/components/nexus/Diferenciais";
import SolucoesCatalog from "@/components/nexus/SolucoesCatalog";
import Numeros from "@/components/nexus/Numeros";
import Depoimentos from "@/components/nexus/Depoimentos";
import Contact from "@/components/nexus/Contact";
import Footer from "@/components/nexus/Footer";
import InternetPage from "@/pages/InternetPage";
import InfraestruturaPage from "@/pages/InfraestruturaPage";

const HashScroller = () => {
  const { hash, pathname } = useLocation();
  useEffect(() => {
    if (pathname === "/" && hash) {
      const id = hash.replace("#", "");
      setTimeout(() => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 80);
    }
  }, [hash, pathname]);
  return null;
};

const Home = () => (
  <>
    <Header />
    <main>
      <Hero />
      <About />
      <BusinessUnits />
      <SolucoesCatalog />
      <Diferenciais />
      <Numeros />
      <Depoimentos />
      <Contact />
    </main>
    <Footer />
  </>
);

function App() {
  return (
    <div className="App">
      <Toaster
        theme="dark"
        position="top-right"
        toastOptions={{
          style: {
            background: "#0A0810",
            color: "#fff",
            border: "1px solid rgba(255,255,255,0.1)",
          },
        }}
      />
      <BrowserRouter>
        <HashScroller />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/internet" element={<InternetPage />} />
          <Route path="/infraestrutura" element={<InfraestruturaPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
